module.exports = __webpack_public_path__ + "img/HomePlusPlan-Icon.28f2dcf3.svg";